module.exports = __webpack_public_path__ + "static/media/kataGaiten.29e5be2e.png";